<script setup lang="ts">
import { computed } from "vue"

const props = defineProps<{
    context: any
}>()

const values = computed<string[]>({
    get() {
        if (props.context.value && Array.isArray(props.context.value) && props.context.value.length > 0) {
            return props.context._value
        }
        return [""]
    },
    set(newValue: string[]) {
        props.context.node.input(newValue.length > 0 ? newValue : null)
    },
})

const addField = () => {
    values.value.push("")
}

const removeField = (index: number) => {
    values.value.splice(index, 1)
    updateValue()
}

const updateValue = () => {
    const filteredValues = values.value.filter(val => val.trim() !== "")
    props.context.node.input(filteredValues.length > 0 ? filteredValues : null)
}
</script>

<template>
    <div class="row">
        <div class="col-12 col-xl-4 col-md-6">
            <div v-for="index in values.length" :key="index" class="d-flex mb-2">
                <input v-model="values[index - 1]" type="text" class="form-control mr-4" @change="updateValue" />
                <button type="button" class="btn btn-primary btn-sm" @click="removeField(index - 1)">
                    <i class="fa fa-fw fa-trash"></i>
                </button>
            </div>
            <div class="text-right">
                <button type="button" class="btn btn-success btn-sm" @click="addField">
                    <i class="fa fa-fw fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
</template>
